const useMachineData = () => {
  const buildCommonMachinePayload = (cameraObj, cameraFormData, selectedModel, isAddingNewArea) => {
    return {
      venueId: cameraObj.venueId,
      machineName: cameraFormData.machineName,
      machineRTSPUrl: cameraFormData.machineRTSPUrl,
      machineCustomId: cameraFormData.machineCustomId,
      machineType: cameraFormData.machineType,
      machineOverlayLabel: cameraFormData.machineOverlayLabel,
      machineInferenceInterval: cameraFormData.machineInferenceInterval,
      machineSelectedObjects: JSON.stringify(cameraFormData.machineSelectedObjects),
      machineIntervalType: selectedModel.valueType,
      modelVersionId: cameraFormData.modelVersionId,
      dockerId: cameraFormData.dockerId,
      areaId: isAddingNewArea ? null : cameraFormData.areaId,
      areaName: isAddingNewArea ? cameraFormData.newArea : null,
      machineModel: cameraFormData.machineModel,
      machineAsyncInference: cameraFormData.machineAsyncInference,
      machineConfidenceThreshold: cameraFormData.machineConfidenceThreshold,
      machineResetInterval: cameraFormData.machineResetInterval,
      machineAntiLag: cameraFormData.machineAntiLag,
      machinePrivacy: cameraFormData.machinePrivacy,
    };
  };
  return {
    buildCommonMachinePayload,
  };
};

export default useMachineData;
